import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

export default function ShareProjectReport() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading|ok|password|expired|notfound|error
  const [report, setReport] = useState(null);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const load = async (pw = '') => {
    setStatus('loading');
    setError('');
    try {
      const { data } = await axios.get(`/api/share/project-report/${token}`, {
        headers: pw ? { 'X-Share-Password': pw } : {},
      });
      setReport(data);
      setStatus('ok');
    } catch (e) {
      const code = e.response?.status;
      if (code === 401) {
        setStatus('password');
        if (pw) setError('Falsches Passwort.');
      } else if (code === 410) setStatus('expired');
      else if (code === 404) setStatus('notfound');
      else setStatus('error');
    }
  };

  useEffect(() => {
    load();
  }, [token]);

  if (status === 'loading') {
    return <CenterCard>Wird geladen…</CenterCard>;
  }

  if (status === 'password') {
    return (
      <CenterCard>
        <h1 className="text-[20px] font-bold mb-1">Passwortgeschützter Report</h1>
        <p className="text-[13px] text-gray-500 mb-4">
          Dieser Report ist durch ein Passwort geschützt.
        </p>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && load(password)}
          placeholder="Passwort"
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-[14px] outline-none focus:border-teal mb-3"
        />
        {error && <div className="text-[12px] text-red-500 mb-2">{error}</div>}
        <button
          onClick={() => load(password)}
          className="w-full px-4 py-2 bg-teal text-white rounded-lg text-[13px] font-medium"
        >
          Report öffnen
        </button>
      </CenterCard>
    );
  }

  if (status === 'expired') {
    return <CenterCard>Dieser Share‑Link ist abgelaufen.</CenterCard>;
  }
  if (status === 'notfound') {
    return <CenterCard>Report nicht gefunden oder Sharing deaktiviert.</CenterCard>;
  }
  if (status === 'error') {
    return <CenterCard>Fehler beim Laden. Bitte später erneut versuchen.</CenterCard>;
  }

  const htmlUrl = `/api/share/project-report/${token}/html${
    password ? `?password=${encodeURIComponent(password)}` : ''
  }`;

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <div className="bg-white border-b border-black/[.07] px-6 py-3 flex items-center justify-between">
        <div>
          <div className="text-[14px] font-bold">{report?.title}</div>
          <div className="text-[11px] text-gray-500">
            {report?.project?.name}
            {report?.data?.period?.label && ` · ${report.data.period.label}`}
          </div>
        </div>
        <a
          href={htmlUrl}
          target="_blank"
          rel="noreferrer"
          className="text-[12px] text-teal font-medium hover:underline"
        >
          Vollansicht öffnen ↗
        </a>
      </div>
      <iframe
        title="shared-report"
        src={htmlUrl}
        className="flex-1 w-full bg-white"
      />
    </div>
  );
}

function CenterCard({ children }) {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-5">
      <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-8 w-[420px] max-w-full">
        {children}
      </div>
    </div>
  );
}
